export function toCssColor(
  color: string | null | undefined,
  fallback?: string
): string | undefined {
  if (!color) return fallback;
  if (color === 'transparent') return 'transparent';
  return color.startsWith('#') ? color : `#${color}`;
}
